define([
	"dojo/_base/declare",
	"dojo/store/Memory",
	"csi/action/EmailController",
	"csi/xml",
	"csi/xml/Search",
	"./DownloadZipController"
], function(declare,Memory,EmailController,xml,Search, DownloadZipController) {

	return declare([DownloadZipController, EmailController], {

		getUsersStoreOptions: function() {
			// summary: pull all Suppliers and Contacts from Suppliers into the list of available email addresses
			var options = this.inherited(arguments);

			var search = new Search({Module:EmailController.USERS_STORES_MODULE, Operation:EmailController.USERS_STORES_OPERATION});

			// suppliers and its contacts
			search.setLimitPath(this.m_urlNode, xml.path("Items", "Item", xml.ATTR_PARENT, "Supplier"));
			search.setLimitPath(this.m_urlNode, xml.path("Items", "Item", xml.ATTR_PARENT, "Supplier", "Contacts"));

			// agents and its contacts
			search.setLimitPath(this.m_urlNode, xml.path("Items", "Item", xml.ATTR_PARENT, "Supplier", "Agent"));
			search.setLimitPath(this.m_urlNode, xml.path("Items", "Item", xml.ATTR_PARENT, "Supplier", "Agent", "Contacts"));

			// assigned agents and their contacts
			search.setLimitPath(this.m_urlNode, xml.path("Items", "Item", "AssignedAgents"));
			search.setLimitPath(this.m_urlNode, xml.path("Items", "Item", "AssignedAgents", "Contacts"));

			var q = search.getQuery();
			q.Attr("Email", xml.OP_NOT_EQUALS, "");

			options.request = search.getRequest();

			return options;
		},

		getAttachmentsStore: function() {
			// summary: returns the attachments' store
			return new Memory({
				idProperty: "$",
				nameProperty: "Name",
				labelProperty: "Name",
				data: [
				    {$: "centric:", Name: this._getAttachmentName()}
				]
			});
		},

		getInitialValues: function() {
			// summary: get initial values for Email form
			var initialValues = this.inherited(arguments);

			initialValues.attachments = ["centric:"];

			return initialValues;
		},

        toWriter: function() {
			// summary: set values to email message
			var call = this.inherited(arguments);

			call.setModuleOperation("SiteAdmin", "EmailSelectSetZip");
			call.addParameter("URL", xml.ATTR_REF, this.m_urlNode);
			call.addParameter("AttachmentName", xml.ATTR_STRING, this._getAttachmentName());
			call.addParameter("IncludeMergedPDF", xml.ATTR_BOOLEAN, this.bIncludeMergedPDF);

			return call;
		},

		_getAttachmentName: function() {
			var node = this.getNode();
			return node.$Name+".zip";
		},

		_onPublishError: function(/*Error*/err) {
		    this.inherited(arguments);
		    this.resumeProcess();
		}
	});
});